module.exports = __webpack_public_path__ + "media/images/pages-contact-arrow-5e65592aa147070960f74008b03e64b2.svg";